module.exports = __webpack_public_path__ + "img/shichi-go-san school visit.849eac58.png";